// Web3Forms submission helper. Sends to the access key from runtime config.
// IMPORTANT for Auto-Response (acknowledgement to the user):
//   - The payload MUST contain a lowercase `email` field (this is what Web3Forms
//     uses as the recipient for the auto-response).
//   - The auto-response itself (subject "Thank you for your enquiry", body, from-name)
//     must be enabled & configured ONCE in the Web3Forms dashboard (PRO feature):
//     https://app.web3forms.com  →  your form  →  Auto Response  →  Enable.
//     See DEPLOY.md for step-by-step instructions.

import { getConfig } from './runtimeConfig';

export const REQUEST_TYPES = {
  BROCHURE: 'Brochure',
  PRICING: 'Pricing',
  GENERAL: 'General Enquiry',
};

export const submitLead = async ({
  name,
  phone,
  email,
  interestedIn = '',
  requestType = REQUEST_TYPES.GENERAL,
  page = '',
  brochureLink = '',
  pricingLink = '',
  extra = {},
}) => {
  const cfg = await getConfig();
  const accessKey = cfg.WEB3FORMS_ACCESS_KEY;
  if (!accessKey) throw new Error('Missing Web3Forms access key');

  const subject = `New Lead - ${requestType}${interestedIn ? ' - ' + interestedIn : ''}`;
  const now = new Date();
  const ts = now.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });

  // Lowercase keys are required by Web3Forms for built-in features:
  //   - `email`      → reply-to + auto-response recipient
  //   - `name`       → used in the auto-response salutation
  //   - `subject`    → subject of the notification email to business
  //   - `from_name`  → "from" display name on the business notification
  //   - `replyto`    → reply-to of the business notification (= user's email)
  const payload = {
    access_key: accessKey,
    subject,
    from_name: 'The NRI Realtor — Website',
    name,
    email,           // REQUIRED for auto-response delivery
    phone,
    replyto: email,
    botcheck: '',

    // Friendly fields (shown verbatim in the business notification email)
    'Full Name': name,
    'Phone': phone,
    'Email': email,
    'Interested In': interestedIn || '—',
    'Request Type': requestType,
    'Page / Source': page || (typeof window !== 'undefined' ? window.location.href : ''),
    'Submitted At (IST)': ts,
    'Brochure Link': brochureLink || '—',
    'Pricing Link': pricingLink || '—',

    // Some Web3Forms templates additionally honour these (free-tier no-op,
    // PRO autoresponder uses the dashboard config instead).
    _autoresponse: `Hi ${name || 'there'},\n\nThank you for your interest in ${interestedIn || 'our offerings'}.\nOur team has received your request and will get back to you shortly with the required details.\n\nRegards,\nThe NRI Realtor`,
    _autoresponse_subject: 'Thank you for your enquiry',

    ...extra,
  };

  const res = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.message || 'Submission failed');
  }
  return data;
};
